//* Bounds over GeoJSON, shared by the maps that frame what they draw: the
//* place page's location map and the places listing's map view.
//*
//* The result is a plain [[west, south], [east, north]] pair rather than a
//* mapboxgl.LngLatBounds. Mapbox knows one of its own bounds objects by
//* instanceof, which does not hold across two copies of the module, and a
//* foreign instance is then read as an array and throws inside fitBounds. The
//* pair is a LngLatBoundsLike whichever copy converts it.

//* Walks a GeoJSON coordinates member — nested to a different depth for every
//* geometry type — and yields each [longitude, latitude] pair it holds.
const eachPosition = function(coordinates, callback) {
  if (!Array.isArray(coordinates)) return;

  if (typeof coordinates[0] === "number") {
    callback(coordinates);
    return;
  }

  coordinates.forEach((nested) => eachPosition(nested, callback));
};

//* The bounds covering every position in the given FeatureCollections, or null
//* when they hold none. Skips anything that is not one, so a caller can pass a
//* value that may be empty.
const geojsonBounds = function(...collections) {
  let west = Infinity, south = Infinity, east = -Infinity, north = -Infinity;

  collections.forEach((geojson) => {
    if (!Array.isArray(geojson?.features)) return;

    geojson.features.forEach((feature) => {
      eachPosition(feature.geometry?.coordinates, ([longitude, latitude]) => {
        west = Math.min(west, longitude);
        east = Math.max(east, longitude);
        south = Math.min(south, latitude);
        north = Math.max(north, latitude);
      });
    });
  });

  if (west === Infinity) return null;

  return [[west, south], [east, north]];
};

const useGeojsonBounds = controller => {
  Object.assign(controller, { eachPosition, geojsonBounds });
};

export { eachPosition, geojsonBounds, useGeojsonBounds };

export default useGeojsonBounds;
